import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { alignSelfConverterMap } from './alignSelfPropsToCss'

/**
 * Enriches the converters registry with all AlignSelf style property converters.
 * AlignSelf converters handle CSS align-self property and related alignment values.
 */
export function enrichAlignSelfConverters(): void {
	// Register all align-self converters
	Object.entries(alignSelfConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
